var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidePasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32128 9.32122C9.15007 9.50496 8.94361 9.65233 8.71421 9.75455C8.4848 9.85676 8.23717 9.91172 7.98606 9.91615C7.73496 9.92058 7.48554 9.87439 7.25267 9.78033C7.01981 9.68628 6.80827 9.54628 6.63069 9.36869C6.45311 9.19111 6.31311 8.97958 6.21905 8.74671C6.12499 8.51385 6.0788 8.26442 6.08323 8.01332C6.08766 7.76222 6.14262 7.51458 6.24484 7.28518C6.34705 7.05578 6.49442 6.84931 6.67816 6.6781M11.7026 11.7025C10.637 12.5148 9.33942 12.9648 7.99972 12.9867C3.63608 12.9867 1.14258 7.99966 1.14258 7.99966C1.91799 6.55461 2.99347 5.29209 4.29686 4.29681L11.7026 11.7025ZM6.69063 3.16226C7.11972 3.06182 7.55903 3.01161 7.99972 3.01265C12.3634 3.01265 14.8569 7.99966 14.8569 7.99966C14.4785 8.70757 14.0272 9.37404 13.5104 9.98823L6.69063 3.16226Z",
    stroke: "#6429CD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.14282 1.14288L14.8571 14.8572",
    stroke: "#6429CD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordIcon);
export default __webpack_public_path__ + "static/media/hidePasswordIcon.57f4593466b48151c75c5b8f88b55c70.svg";
export { ForwardRef as ReactComponent };